import React from 'react';

const FeatureItem = ({ image, text }) => {
  return (
    <div
      className="feature flex flex-col md:flex-row justify-center items-center flex-wrap aos-init aos-animate my-4"
      data-aos="fade-right"
      data-aos-duration="1000"
    >
      <div className="feature-icon">
        <img
          alt="Feature"
          loading="lazy"
          className="mx-auto w-11 h-11 md:w-16 md:h-16"
          src={image}
        />
      </div>
      <p className="feature-text text-center py-2 md:ml-4 w-2/3 md:w-auto mx-auto">
        {text}
      </p>
    </div>
  );
};

function Features({ workflow }) {
  return (
    <section className="section pt-12 flat features" id="features">
      <h2
        className="section-title text-center text-brandPrimary md:text-black text-2xl md:text-4xl aos-init aos-animate"
        data-aos="fade-up"
        data-aos-duration="500"
      >
        Premiere services covering
        <br /> all your needs
      </h2>
      <div className="features-block flex flex-col md:flex-row justify-center md:justify-evenly items-center mt-10">
        <div className="features-section flex flex-col justify-center items-center md:items-start">
          <FeatureItem
            image="https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/feature-1.svg"
            text="3 Million+ Stock Footage Library"
          />
          <FeatureItem
            image="https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/feature-2.svg"
            text="24x7 World Class Support"
          />
          <FeatureItem
            image="https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/feature-3.svg"
            text="Automated Text-To-Speech"
          />
          <FeatureItem
            image="https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/feature-4.svg"
            text="Unlimited Team Members"
          />
        </div>
        <div className="features-section flex flex-col justify-center items-center md:items-start">
          <FeatureItem
            image="https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/feature-1.svg"
            text="1 Million+ Premium Video Library"
          />
          <FeatureItem
            image="https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/feature-5.svg"
            text="5000+ Readymade Video Templates"
          />
          <FeatureItem
            image="https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/feature-6.svg"
            text="Make videos in your language"
          />
          <FeatureItem
            image="https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/feature-7.svg"
            text="Automated Voiceovers"
          />
        </div>
      </div>
      <div className="bottom-action text-center mt-10">
        <p className="signup-text text-brandPrimary text-lg mb-4">
          Sign up today and try for free.
        </p>
        <div className="action">
          <h3
            className="btn signUp-btn w-48 mx-auto p-4 rounded-lg bg-brandPrimary text-white cursor-pointer"
            onClick={() => workflow('workflow')}
            aria-hidden
          >
            Create Free Account
          </h3>
        </div>
      </div>
    </section>
  );
}

export default Features;
